import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ResetPassword from "../components/ResetPassword";
import EmailVerification from "./EmailVerification";

function EmailVerificationPage() {
    return (
        <div>
            <Navbar />
            <EmailVerification />
            <Footer />
        </div>
    )
}

export default EmailVerificationPage;